// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { makeApiMessage } from "../../../components/src/common";
import { ZatcaHistory } from "./utils";
import { IFilter } from "../../../components/src/FilterPopover";
import moment from "moment";
import { IUserContext } from "../../navigationmenu/src/PageContainerController.web";
import {
  checkForOrderPermissonStatus,
  customPermissionApiKey,
  checkIsFilterApplied,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import { isEqual } from "lodash"

// Customizable Area End

// Customizable Area Start
export const configJSON = require("./config");

interface IFilterOmitValue extends Omit<IFilter, "value"> {
  value?: string | string[] | Date[] | null | [undefined, undefined];
}
export interface IFilterItem extends Omit<IFilterOmitValue, "apiKey"> {
  apiKey?: string | string[];
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: unknown;
  id: string;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  zatacaHistoryList: Array<ZatcaHistory>;
  isLoading: boolean;
  selectedFromDate: string;
  selectedToDate: string;
  snackbarOpen: boolean;
  snackbarMessage: string;
  snakcbarSeverity: "error" | "success" | "warning";
  selectedDate: Date | null | string | undefined;
  permissionStatus: boolean;
  page: number;
  pageSize: number;
  meta: {
    next_page: number;
    pervious_page: number;
    total_pages: number;
    total_count: number;
    current_page: number;
  };

  storeId: string;
  isAppliedFilter: boolean;
  filterAnchor: { currentTarget: {} } | undefined | HTMLDivElement;
  sectionList: { attributes: { section_name: string; id: number } }[];
  filters: IFilterItem[];
  suggestionFieldTitle: string;
  searchCatalogue: string;
  selectedBranches:any;
  onloadReduceApiCall:boolean;
  viewDialogOpen: boolean;
  selectedZatcaResponse: any;
  // Customizable Area End
}

interface SS {
  // Customizable Area Start
  // Customizable Area End
}

export default class ZatcaHistoryController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getZatcaLogsHistoryCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.LayoutDataMessage),
      getName(MessageEnum.BroadcastNavbarDataMessage),
      getName(MessageEnum.SearchTextMessage),
    ];
    // Customizable Area End

    // Customizable Area Start
    this.state = {
      zatacaHistoryList: [],
      isLoading: false,
      selectedFromDate: "",
      selectedToDate: "",
      snackbarOpen: false,
      snackbarMessage: "",
      snakcbarSeverity: "error",
      selectedDate: null,
      permissionStatus: true,
      page: 0,
      pageSize: 50,
      meta: {
        next_page: 1,
        pervious_page: 1,
        total_pages: 1,
        total_count: 1,
        current_page: 1,
      },

      storeId: "",
      isAppliedFilter: false,
      filterAnchor: undefined,
      sectionList: [],
      filters: [
        {
          title: "Status",
          type: "select",
          value: "",
          options: [
            { label: "Pass", value: "PASS" },
            { label: "Warning", value: "WARNING" },
            { label: "Fail", value: "FAIL" },
          ],
        },
        {
          title: "Document Type",
          value: "",
          type: "select",
          options: [
            { label: "CN", value: "CN" },
            { label: "SI", value: "SI" },

          ],
        },
        {
          title: "Sent Status",
          value: "",
          type: "select",
          options: [
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ],
        },
      ],
    suggestionFieldTitle: "",
    searchCatalogue: "",
    selectedBranches:[],
  onloadReduceApiCall:false,
  viewDialogOpen: false,
  selectedZatcaResponse: null

    };
    // Customizable Area End

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    this.handleStorageFilter();
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
   
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      if (apiRequestCallId === this.getZatcaLogsHistoryCallId) {
        this.handleZatcaLogsHistoryResponse(message);
      }
    }
    this.receiveLayoutData(message)
    this.receiveSearchTextData(message)
    this.receiveDataFromHeader(message)

    // Customizable Area End
  }

  // Customizable Area Start

  receiveSearchTextData = (message: Message) => {
    if (message.id === getName(MessageEnum.SearchTextMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.SearchMessageText)
        );
        if (recievedData) {
          this.handleSearchPlant(recievedData.searchText)
        }
    }
  }
  receiveDataFromHeader = (message: Message) => {
    if (message.id === getName(MessageEnum.BroadcastNavbarDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.BroadcastNavbarData)
      );

      const { storeId } = recievedData;
      if (storeId && !isEqual(this.state.selectedBranches, storeId.split(','))) {
        this.setState({ selectedBranches: storeId.split(',') }, () => {         
            this.getZatcaLogsHistory();
        });
      }
    }
  }
  getZatcaLogsHistory = () => {
    this.setState({ isLoading: true });
    const { selectedFromDate, selectedToDate, page, pageSize, searchCatalogue, filters, selectedBranches } = this.state;

    const fromDate = selectedFromDate?.trim();
    const toDate = selectedToDate?.trim();
    const searchValue = searchCatalogue?.trim();
    const statusFilter = filters[0]?.value;
    const invoiceTypeFilter = filters[1]?.value;
    const sentStatusFilter = filters[2]?.value;
    const fromFilterQuery = fromDate ? `&start_date=${fromDate}` : "";
    const toFilterQuery = toDate ? `&end_date=${toDate}` : "";
    const paginationQuery = `?page=${page + 1}&per=${pageSize}`;
    const searchQuery = searchValue ? `&filter_by[query]=${searchValue}` : "";

    const branchIds = selectedBranches
      .map((id: any) => id?.toString().trim())
      .filter((id: string) => id)
      .join(",");

    const statusQuery = statusFilter ? `&filter_by[status]=${statusFilter}` : "";
    const invoiceTypeQuery = invoiceTypeFilter ? `&filter_by[invoice_type]=${invoiceTypeFilter}` : "";
    const sentStatusQuery = sentStatusFilter ? `&filter_by[sent_status]=${sentStatusFilter}` : "";

    const url =
      configJSON.zatcaLogsHistoryEndPoint +
      paginationQuery +
      `&store_ids=${branchIds}` +
      fromFilterQuery +
      toFilterQuery +
      searchQuery +
      statusQuery +
      invoiceTypeQuery +
      sentStatusQuery;
  
    let message = makeApiMessage({
      url,
      method: "GET",
    });
  
    this.getZatcaLogsHistoryCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleStorageFilter = () => {
    const applied_zatca_filter_value = localStorage.getItem("zatca_filter_value");
    if(applied_zatca_filter_value) {
      this.setState({
        filters: JSON.parse(applied_zatca_filter_value),
        isAppliedFilter: checkIsFilterApplied(JSON.parse(applied_zatca_filter_value))
      });
    };
  };
  

  handleZatcaLogsHistoryResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (responseJson && !responseJson.error) {
      this.setState({
        zatacaHistoryList: responseJson.data,
        meta: responseJson.meta,
      });
    }

    this.setState({ isLoading: false });
  };

  handleSearchPlant = (value: string) => {	
    this.setState(	
      {	
        page: 0,
        searchCatalogue: value,	
      },	
      this.getZatcaLogsHistory	
    );
  };	

  handleSendtozatcaDate = (date: string) => {
    if (date) { return `${moment(date).format("L")} ${moment(date).format("LT")}`; }
  };

  handleAppliedFilter = () => {
    const { selectedFromDate, selectedToDate } = this.state;
    if (selectedFromDate && selectedToDate) {
      this.setState({ page: 0 }, () => this.getZatcaLogsHistory());
    } else {
      this.setState({
        snackbarOpen: true,
        snackbarMessage: "Please selecte from and to date",
      });
    }
  };

  handleClearFilter = () => {
    let updated = this.state.filters.map((item: IFilterItem) => {
      if (item.title === "Status" || item.title === "Document Type" || item.title === "Sent Status") item.value = null;
      else item.value = "";
      return item;
    });
    this.setState(
      {
        filters: updated,
        selectedFromDate: "",
        selectedToDate: "",
        page: 0,
        isAppliedFilter: false
      });
    setTimeout(() => this.handleFilterChange(updated as IFilter[]), 1000);
  };

  handleFromDate = (selectedDate: Date | null) => {
    if (selectedDate) {
      this.setState({
        selectedFromDate: moment(selectedDate).format("YYYY-MM-DD"),
      });
    }
  };

  handleToDate = (selectedDate: Date | null) => {
    if (selectedDate) {
      this.setState({
        selectedToDate: moment(selectedDate).format("YYYY-MM-DD"),
      });
    }
  };

  handleSnackbarClose = () => this.setState({snackbarOpen: false});

  receiveLayoutData = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.LayoutMessageData)
      );
      if(recievedData.userContext) {
        this.handleOnUserChange(recievedData.userContext)
      }
    }
  }

  handleOnUserChange = (userContext: IUserContext) => {
    const apiKey = customPermissionApiKey.orderPermission;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForOrderPermissonStatus(
      apiKey,
      userData as Array<PermissionGroupArray>
    );

    this.setState({
      permissionStatus: value.zatcaLogsAccess ? true : false,
    },() => {
      setTimeout(() => {
        this.setState({onloadReduceApiCall:true})
      }, 1000)});
  };

  handlePageChange =(page: number) => this.setState({ page }, () => this.getZatcaLogsHistory());

  handleReturnColorType = () => {
    const { isAppliedFilter } = this.state;
    return isAppliedFilter ? "primary" : "inherit";
  };

    handleFilterChange = (filters: IFilter[]) => {
      if (checkIsFilterApplied(filters)) {
        localStorage.setItem("zatca_filter_value", JSON.stringify(filters));
      } else {
        localStorage.removeItem("zatca_filter_value");
      };
  
      this.setState(
        {
          filters,
          isAppliedFilter: checkIsFilterApplied(filters)
        },()=>this.getZatcaLogsHistory()
      );
    };

    handleCall(){
      this.handleReturnColorType();
      this.handlePageChange(1);
      this.handleSnackbarClose();
      this.setState({onloadReduceApiCall: true})
    }

    handleFilterAnchor(event?: React.MouseEvent<HTMLDivElement, MouseEvent>) {
      this.setState({ 
        filterAnchor: event?.currentTarget 
      });
    }

    handleAutocompleteFilterChange(title: string, value: string) {
      this.setState({ suggestionFieldTitle: title });
    }

    handleSetStateFilter = (filters: IFilterItem[]) => {
        this.setState({ filters })
      };

    handleOpenViewDialog = (response: any) => {
      this.setState({ viewDialogOpen: true, selectedZatcaResponse: response });
    };

    handleCloseViewDialog = () => {
      this.setState({ viewDialogOpen: false, selectedZatcaResponse: null });
    };

  // Customizable Area End
}
